import axiosInstance from "../api/axiosInstance";
import API_ENDPOINTS from "../api/endpoints";

const LocationService = {
    getAllCountries: (params) =>
        axiosInstance.get(API_ENDPOINTS.Country.GET_ALL_COUNTRIES, {
            params,
        }),

    getCountryById: (id) =>
        axiosInstance.get(API_ENDPOINTS.Country.GET_COUNTRY_BY_ID(id)),

    createCountry: (data) =>
        axiosInstance.post(API_ENDPOINTS.Country.CREATE_COUNTRY, data),

    updateCountry: (id, data) =>
        axiosInstance.put(API_ENDPOINTS.Country.UPDATE_COUNTRY(id), data),

    deleteCountry: (id) =>
        axiosInstance.delete(API_ENDPOINTS.Country.DELETE_COUNTRY(id)),


    getAllStates: (params) =>
        axiosInstance.get(API_ENDPOINTS.State.GET_ALL_STATES, {
            params,
        }),

    getStateById: (id) =>
        axiosInstance.get(API_ENDPOINTS.State.GET_STATE_BY_ID(id)),

    createState: (data) =>
        axiosInstance.post(API_ENDPOINTS.State.CREATE_STATE, data),

    updateState: (id, data) =>
        axiosInstance.put(API_ENDPOINTS.State.UPDATE_STATE(id), data),

    deleteState: (id) =>
        axiosInstance.delete(API_ENDPOINTS.State.DELETE_STATE(id)),


    getAllCities: (params) =>
        axiosInstance.get(API_ENDPOINTS.City.GET_ALL_CITIES, {
            params,
        }),

    getCityById: (id) =>
        axiosInstance.get(API_ENDPOINTS.City.GET_CITY_BY_ID(id)),

    createCity: (data) =>
        axiosInstance.post(API_ENDPOINTS.City.CREATE_CITY, data),

    updateCity: (id, data) =>
        axiosInstance.put(API_ENDPOINTS.City.UPDATE_CITY(id), data),

    deleteCity: (id) =>
        axiosInstance.delete(API_ENDPOINTS.City.DELETE_CITY(id)),
};

export default LocationService;